import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ApproverService } from '../../../core/services/approver.service';
import { PopupMessageService } from '../../../shared/message/services/message.service';

@Component({
  selector: 'app-approve-modal',
  templateUrl: './approve-modal.component.html',
  styleUrls: ['./approve-modal.component.scss']
})
export class ApproveModalComponent implements OnChanges {

  @Input() isOpen: boolean = false;
  @Input() data: any;
  @Output() close = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  approveComments = '';

  constructor(
    private approverService: ApproverService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && this.isOpen) {
      this.approveComments = '';
    }
  }

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    const req = '?userChallengeId=' + this.data.userChallengeId + '&fileId=' + this.data.fileId +
      '&status=APPROVED&comments=' + this.approveComments;
    this.approverService.updateStatus(req).subscribe(() => {
      this.approveComments = '';
      this.popupMessageService.showSuccess('Status updated successfully.', 'success');
      this.confirmed.emit();
    });
  }
}
